import { render } from "./CollectionDetailedSearchPackagedDigitalPublications.vue?vue&type=template&id=6cc122b8&scoped=true&ts=true"
import script from "./CollectionDetailedSearchPackagedDigitalPublications.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchPackagedDigitalPublications.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchPackagedDigitalPublications.vue?vue&type=style&index=0&id=6cc122b8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc122b8"]])

export default __exports__